import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  VertButton,
  VertCheckbox,
  VertModal,
  VertTypography,
} from '@vertem-core/vertice-ds';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsValidToCheckout,
  setIsVisibleDifalModal,
} from 'redux/Reducers/Spot/spotAproveRedemption';

const SpotDifal = ({ isValidToCheckout, setIsValidToCheckout }) => {
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isVisibleDifal, setIsVisibleDifal] = useState(false);

  useEffect(() => {
    handleValidateDocument();
  }, []);

  const handleValidateDocument = () => {
    setIsValidToCheckout();
    setIsVisibleDifal(true);
  };

  function closeModal() {
    setIsVisibleModal(false);
  }

  return (
    isVisibleDifal && (
      <>
        <div className="box-terms-aprovation">
          <VertCheckbox
            value={isValidToCheckout}
            onChange={(e) => setIsValidToCheckout()}
          >
            <VertTypography.Text strong>
              Aceito os termos
            </VertTypography.Text>
          </VertCheckbox>
          <VertTypography.Text strong>
            <a
                onClick={() => setIsVisibleModal(true)}
                className="link-view-redemption"
                style={{
                  marginLeft: '0.25em'
                }}
            >
              DIFAL ICMS
            </a>
          </VertTypography.Text>
        </div>

        <VertModal
          centered
          open={isVisibleModal}
          onCancel={closeModal}
          onOk={closeModal}
          title={'DIFAL (Diferencial de Alíquota do ICMS)'}
          className="modal-terms-aprovation"
          footer={[
            <div className="box-terms-modal-footer">
              <VertButton key="submit" type="default" onClick={closeModal}>
                Fechar
              </VertButton>
            </div>,
          ]}
        >
          <VertTypography.Text className="text-terms-modal">
            <VertTypography.Paragraph strong>ATENÇÃO</VertTypography.Paragraph>{' '}
            Em caso de incidência de DIFAL sobre o resgate de produtos no
            catálogo de prêmios, o custeio dessa taxa é de responsabilidade do
            participante.
          </VertTypography.Text>
        </VertModal>
      </>
    )
  );
};

export default SpotDifal;
